// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + "shipbob_carrier_ui_styles" + "." + "3c66d897" + ".chunk.css";
};